import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
Vue.use(VueRouter);
const routes = [
    /**主要页面路由 */
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            title: "首页",
        },
    },
    {
        path: "/wx/zixun/index",
        name: "zixun",
        component: () =>
            import (
                /* webpackChunkName: "dataStatistics" */
                "../views/zixun/index.vue"
            ),
        meta: {
            title: "肿瘤资讯",
        },
    },
    {
        path: "/zixun/detail",
        name: "detail",
        component: () =>
            import (
                /* webpackChunkName: "dataStatistics" */
                "../views/zixun/detail.vue"
            ),
        meta: {
            title: "详情",
        },
    },
    {
        path: "/wx/zixun/detail",
        name: "wxdetail",
        component: () =>
            import (
                /* webpackChunkName: "dataStatistics" */
                "../views/zixun/detail.vue"
            ),
        meta: {
            title: "详情",
        },
    },
    {
        path: "/datacount/dataStatistics",
        name: "dataStatistics",
        component: () =>
            import (
                /* webpackChunkName: "dataStatistics" */
                "../views/datacount/dataStatistics.vue"
            ),
        meta: {
            title: "数据统计",
        },
    },

    {
        path: "/datacount/geneStatistics",
        name: "geneStatistics",
        component: () =>
            import (
                /* webpackChunkName: "dataStatistics" */
                "../views/datacount/geneStatistics.vue"
            ),
        meta: {
            title: "基因解读",
        },
    },
    {
        path: "/datacount/cancerStatistics",
        name: "cancerStatistics",
        component: () =>
            import (
                /* webpackChunkName: "dataStatistics" */
                "../views/datacount/cancerStatistics.vue"
            ),
    },

    {
        path: "/datacount/mutationfrequency",
        name: "mutationfrequency",
        component: () =>
            import (
                /* webpackChunkName: "dataStatistics" */
                "../views/datacount/mutationfrequency.vue"
            ),
    },
    {
        path: "/reportQuery/index",
        name: "reportIndex",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/index.vue"
            ),
        meta: {
            title: "报告详情",
        },
    },
    {
        path: "/reportQuery/brain13",
        name: "brain13",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/brain13.vue"
            ),
        meta: {
            title: "报告详情",
        },
    },
    {
        path: "/reportQuery/variationDetails",
        name: "variationDetails",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/variationDetails.vue"
            ),
        meta: {
            title: "体细胞变异详情",
        },
    },
    {
        path: "/reportQuery/geneVariation",
        name: "geneVariation",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/geneVariation.vue"
            ),
        meta: {
            title: "肿瘤发生发展相关基因变异（临床意义不明)",
        },
    },

    {
        path: "/reportQuery/chemotherapy",
        name: "chemotherapy",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/chemotherapy.vue"
            ),
        meta: {
            title: "化疗药物提示",
        },
    },
    {
        path: "/reportQuery/embryoDetails",
        name: "embryoDetails",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/embryoDetails.vue"
            ),
    },
    {
        path: "/reportQuery/embryoAll",
        name: "embryoAll",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/embryoAll.vue"
            ),
    },
    {
        path: "/reportQuery/tmbMsi",
        name: "tmbMsi",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/tmbMsi.vue"
            ),
    },
    {
        path: "/reportQuery/newRamucirumab",
        name: "newRamucirumab",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/components/index/newRamucirumab.vue"
            ),
        meta: {
            title: "其他获批本癌种药物提示",
        },
    },
    {
        path: "/reportQuery/newReference",
        name: "newReference",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/components/index/newReference.vue"
            ),
        meta: {
            title: "参考文献",
        },
    },
    {
        path: "/reportQuery/newZlAssess",
        name: "newZlAssess",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/components/index/newZlAssess.vue"
            ),
        meta: {
            title: "样本主要质控",
        },
    },
    {
        path: "/reportQuery/newYcygVariation",
        name: "newYcygVariation",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/components/index/newYcygVariation.vue"
            ),
        meta: {
            title: "遗传易感相关变异",
        },
    },
    {
        path: "/reportQuery/AlkDetails",
        name: "AlkDetails",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/AlkDetails.vue"
            ),
        meta: {
            title: "重要基因检测",
        },
    },
    {
        path: "/reportQuery/importantGeneDetails",
        name: "importantGeneDetails",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/importantGeneDetails.vue"
            ),
        meta: {
            title: "详情",
        },
    },
    {
        path: "/reportQuery/patientPage",
        name: "patientPage",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/patientPage.vue"
            ),
    },
    {
        path: "/wx/wxIndex",
        name: "wxIndex",
        component: () =>
            import ( /* webpackChunkName: "reportQuery" */ "../views/wx/wxIndex.vue"),
        meta: {
            title: "报告详情",
        },
    },
    {
        path: "/wx/embryoDetails",
        name: "wxembryoDetails",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/embryoDetails.vue"
            ),
        meta: {
            title: "变异详情",
        },
    },
    {
        path: "/wx/embryoAll",
        name: "embryoAll",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/embryoAll.vue"
            ),
    },
    {
        path: "/wx/AlkDetails",
        name: "AlkDetails",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/AlkDetails.vue"
            ),
        meta: {
            title: "重要基因检测",
        },
    },
    {
        path: "/wx/newYcygVariation",
        name: "wxnewYcygVariation",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/components/index/newYcygVariation.vue"
            ),
        meta: {
            title: "遗传易感相关变异",
        },
    },
    {
        path: "/wx/importantGeneDetails",
        name: "importantGeneDetails",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/importantGeneDetails.vue"
            ),
        meta: {
            title: "详情",
        },
    },
    {
        path: "/reportQuery/new",
        name: "new",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/new.vue"
            ),
    },
    {
        path: "/reportQuery/appText",
        name: "appText",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/appText.vue"
            ),
    }, ,
    {
        path: "/serviceAgreement",
        name: "serviceAgreement",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/serviceAgreement/serviceAgreement.vue"
            ),
    },
    {
        path: "/privacyAgreement",
        name: "recruitment",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/privacyAgreement.vue"
            ),
    },
    {
        path: "/approvalAuthorization",
        name: "recruitment",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/approvalAuthorization.vue"
            ),
    },
    {
        path: "/answerQuestion",
        name: "answerQuestion",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/answerQuestion.vue"
            ),
    },
    {
        path: "/wx/siteJiedu",
        name: "siteJiedu",
        component: () =>
            import ( /* webpackChunkName: "reportQuery" */ "../views/wx/siteJiedu.vue"),
        meta: {
            title: "位点解读",
        },
    },
    {
        path: "/wx/geneJiedu",
        name: "geneJiedu",
        component: () =>
            import ( /* webpackChunkName: "reportQuery" */ "../views/wx/geneJiedu.vue"),
        meta: {
            title: "基因解读",
        },
    },
    {
        path: "/wx/tmbMsi",
        name: "wxtmbMsi",
        component: () =>
            import ( /* webpackChunkName: "reportQuery" */ "../views/wx/tmbMsi.vue"),
        meta: {
            title: "免疫药物治疗提示",
        },
    },
    {
        path: "/wx/myGenejiance",
        name: "myGenejiance",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/myGenejiance.vue"
            ),
        meta: {
            title: "可能影响免疫治疗疗效的基因检测结果",
        },
    },
    {
        path: "/wx/variationDetails",
        name: "wxvariationDetails",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/variationDetails.vue"
            ),
        meta: {
            title: "体细胞变异详情",
        },
    },
    {
        path: "/wx/chemotherapy",
        name: "wxchemotherapy",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/chemotherapy.vue"
            ),
        meta: {
            title: "化疗药物提示",
        },
    },
    {
        path: "/wx/newZlAssess",
        name: "wxnewZlAssess",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/newZlAssess.vue"
            ),
        meta: {
            title: "样本主要质控",
        },
    },
    {
        path: "/wx/newReference",
        name: "wxnewReference",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/newReference.vue"
            ),
        meta: {
            title: "参考文献",
        },
    },
    {
        path: "/wx/ybMedicine",
        name: "ybMedicine",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/ybMedicine.vue"
            ),
        meta: {
            title: "医保药物数据库",
        },
    },

    {
        path: "/wx/ybMedicineDetails",
        name: "ybMedicineDetails",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/ybMedicineDetails.vue"
            ),
        meta: {
            title: "医保药物详情",
        },
    },
    {
        path: "/wx/variationTest",
        name: "variationTest",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/variationTest.vue"
            ),
        meta: {
            title: "变异相关临床试验",
        },
    },
    {
        path: "/wx/cishanMedicine",
        name: "cishanMedicine",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/cishanMedicine.vue"
            ),
        meta: {
            title: "慈善药物",
        },
    },
    {
        path: "/wx/recruitment",
        name: "recruitment",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/Recruitment.vue"
            ),
        meta: {
            title: "受检者招募",
        },
    },
    {
        path: "/wx/privacyAgreement",
        name: "recruitment",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/wx/privacyAgreement.vue"
            ),
        meta: {
            title: "用户隐私协议",
        },
    },
    {
        path: "/wx/serviceAgreement",
        name: "serviceAgreement",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/serviceAgreement/serviceAgreement.vue"
            ),
        meta: {
            title: "用户服务协议",
        },
    },
    {
        path: "/order/refundDetails",
        name: "refundDetails",
        props: true,
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/orderCycle/refundManage/refundDetails.vue"
            ),
        meta: {
            title: "退款申请",
        },
    },
    {
        path: "/order/refundApproval",
        name: "refundApproval",
        props: true,
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/orderCycle/refundManage/refundApproval.vue"
            ),
        meta: {
            title: "退款详情",
        },
    },
    {
        path: "/order/test",
        name: "test",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/orderCycle/refundManage/test.vue"
            ),
        meta: {
            title: "列表",
        },
    },
    // 申请发票
    {
        path: "/order/applyInvoice",
        name: "applyInvoice",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "@/views/orderCycle/invoiceManage/applyInvoice.vue"
            ),
        meta: {
            title: "申请发票",
        },
    },
    // 查看发票
    {
        path: "/order/invoiceDetail",
        name: "invoiceDetail",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "@/views/orderCycle/invoiceManage/invoiceDetail.vue"
            ),
        meta: {
            title: "查看发票",
        },
    },
    {
        path: "/statisticsIndex",
        name: "statisticsIndex",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "@/views/statisticalChart/statisticsIndex.vue"
            ),
        meta: {
            title: "统计图",
        },
    },
    {
        path: "/reportQuery/testingExplain",
        name: "testingExplain",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/reportQuery/testingExplain.vue"
            ),
        meta: {
            title: "检测局限性说明",
        },
    },
    // 公众号跳转小程序 因版本太低 访问此路由
    {
        path: "/backupPage/backup",
        name: "backup",
        component: () =>
            import (
                /* webpackChunkName: "reportQuery" */
                "../views/backupPage/backup.vue"
            ),
        meta: {
            title: "升级微信客户端",
        },
    },
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: () => ({
        y: 0,
    }),
    /*  回顶*/
});
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});
export default router;